<template>

    <div v-if="stats">
      <div class="dash-heading"><i class="fa fa-globe" />&nbsp;Management Summary</div><br />

      <el-tabs type="border-card" tab-position="top">
        <el-tab-pane v-if="isProjectView()" lazy>
          <template #label><span><i class="fa fa-broadcast-tower"></i> Project Summary</span></template>
          <project-summary />
        </el-tab-pane>



        <el-tab-pane v-if="isMaintView()" lazy>
          <template #label><span><i class="fa fa-headset"></i> Tickets</span></template>
          <maintenance-summary />
        </el-tab-pane>



        <el-tab-pane v-if="isMaintView()" lazy>
          <template #label><span><i class="fa fa fa-list"></i> Site Workflow</span></template>
          <site-workflow />
        </el-tab-pane>



        <el-tab-pane v-if="isPropertyView()" lazy>
          <template #label><span><i class="fa fa-home"></i> Property Summary</span></template>
          <property-summary  />
        </el-tab-pane>



        <el-tab-pane v-if="isPropertyView()" lazy>
          <template #label><span><i class="fa fa-calendar-day"></i> Expiry</span></template>
          <expiry-table  />
        </el-tab-pane>



        <el-tab-pane v-if="isPropertyView()" lazy>
          <template #label><span><i class="fa fa-asterisk"></i> Tenancy Due</span></template>
          <tenancy-due />
        </el-tab-pane>



        <el-tab-pane v-if="isPropertyView()" lazy>
          <template #label><span><i class="fa fa-calendar-week"></i> Rental by Month</span></template>
          <property-rental-month />
        </el-tab-pane>



        <el-tab-pane v-if="isFinanceView()" lazy>
          <template #label><span><i class="fa fa-money-alt"></i> Finance Summary</span></template>
          <finance-summary  />
        </el-tab-pane>

        <el-tab-pane v-if="isFinanceView()" lazy>
          <template #label><span><i class="fa fa-dollar-sign">&nbsp;</i>Invoicing</span></template>
          <invoicing-view />
        </el-tab-pane>



        <el-tab-pane v-if="isAdminView()" lazy>
          <template #label><span><i class="fa fa-chart-pie"></i> Sites &amp; Operations</span></template>

          <el-row>
            <div class="dash-heading">Sites</div>
            <el-col :xs="24":sm="14" :md="16" :lg="12">
              <sites-chart :show-legend="false" :stats="stats" />
            </el-col>

            <el-col :xs="24" :sm="10" :md="8" :lg="8">
              <sites-stats-table />
            </el-col>
          </el-row>

          <div v-if="canAccess('project|maintenance|admin|management') && stats.actions && stats.tickets && !isProjectView()">
            <el-row>
              <div class="dash-heading">Operations</div>
            </el-row>

            <el-row v-if="canAccess('project|maintenance|admin') && (stats.actions || stats.tickets)">
              <op-stats :stats="stats" />
            </el-row>
          </div>

        </el-tab-pane>



        <el-tab-pane  v-if="isTowerCo() && canAccess('management|project|maintenance|finance|admin')" lazy>
          <template #label><span><i class="fa fa-users"></i> Sharer Summary</span></template>

            <el-row>
              <div class="dash-heading">Sharers</div>
            </el-row>

            <sharer-report :show-ways="true" />

            <sharing-summary-report title-class="dash-heading" hide-org-badge />

        </el-tab-pane>



        <el-tab-pane v-if="isTowerCo() && canAccess('project|finance|maintenance|admin')" lazy>
          <template #label><span><i class="fa fa-download"></i> Request Files</span></template>

          <el-row>
            <div class="dash-heading">Requests Files</div>
          </el-row>
          <files-request-table  />
        </el-tab-pane>

        <el-tab-pane  v-if="isTowerCo() && isAdminView() && canAccess('finance|admin')" lazy>
          <template #label><span><i class="fa fa-plug">&nbsp;</i>{{utilLabel + ' Bills'}}</span></template>

          <utilities-table />
        </el-tab-pane>

        <el-tab-pane v-if="isTowerCo() && canAccess('maintenance|finance|management|admin')" lazy>
          <template #label><span><i class="fa fa-calendar">&nbsp;</i>Calendar</span></template>

          <div class="padded">
            <events-calendar />
          </div>
        </el-tab-pane>



      </el-tabs>

    </div>
</template>


<script>

import NumberMixins from '@/mixins/NumberMixins'

import OpStats from '@/components/dashboard/OpStats'
import SitesChart from '@/components/dashboard/charts/SitesChart'
import SitesStatsTable from '@/components/dashboard/sites/SitesStatsTable'

import SharerReport from '@/components/dashboard/sharers/SharerReport'
import SharingSummaryReport from '@/components/dashboard/sharers/SharingSummaryReport'

import EventsCalendar from '@/components/atoms/EventsCalendar'

import ExpiryTable from '@/components/property/ExpiryTable'
import PropertyRentalMonth from '@/components/dashboard/property/PropertyRentalMonth'
import TenancyDue from '@/components/dashboard/property/TenancyDue'

import FilesRequestTable from '@/components/tables/FilesRequestTable'
import UtilitiesTable from '@/components/utility/UtilitiesTable'
import InvoicingView from '@/components/finance/InvoicingView'

import SiteWorkflow from '@/components/workflow/site/SiteWorkflow'


import FinanceSummary from '@/components/dashboard/views/FinanceSummary'
import ProjectSummary from '@/components/dashboard/views/ProjectSummary'
import MaintenanceSummary from '@/components/dashboard/views/MaintenanceSummary'
import PropertySummary from '@/components/dashboard/views/PropertySummary'

export default {
  mixins: [NumberMixins],

  components: {
    EventsCalendar,
    ExpiryTable,
    FilesRequestTable,
    InvoicingView,
    SharerReport,
    SharingSummaryReport,
    SitesChart,
    SitesStatsTable,
    SiteWorkflow,
    OpStats,
    FinanceSummary,
    TenancyDue,
    PropertyRentalMonth,
    PropertySummary,
    ProjectSummary,
    MaintenanceSummary,
    UtilitiesTable
  },

  data () {
    return {
      utilLabel: this.getUtilLabel(),
      stats: null
    }
  },

  computed: {
    clientLogo () {
      const path = this.xolasClient().logoPath
      return path ? this.getStore().hostname + path : null
    }
  },

  created () {

    this.stats = this.getStats()
//    console.log('Profile Default View', this.profile())

  }

}
</script>
